import {
  SHOW_IMAGE_BACKDROP,
  CLOSE_IMAGE_BACKDROP,
  SHOW_VIDEO_BACKDROP,
  CLOSE_VIDEO_BACKDROP,
} from "../actions/types";

const initialState = {
  imageBackdropStatus: false,
  selectedImage: null,
  videoBackdropStatus: false,
  selectedVideo: null,
};

const backdropsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_IMAGE_BACKDROP:
      return {
        ...state,
        imageBackdropStatus: true,
        selectedImage: action.payload,
      };

    case CLOSE_IMAGE_BACKDROP:
      return {
        ...state,
        imageBackdropStatus: false,
        selectedImage: null,
      };

    case SHOW_VIDEO_BACKDROP:
      return {
        ...state,
        videoBackdropStatus: true,
        selectedVideo: action.payload,
      };

    case CLOSE_VIDEO_BACKDROP:
      return {
        ...state,
        videoBackdropStatus: false,
        selectedVideo: null,
      };

    default:
      return state;
  }
};

export default backdropsReducer;
